<template>
  <div>
        <vx-card v-if="showMatches" class="mb-10">
      <div class="relative">
        <div>
          <vs-button @click="goBack" color="primary" type="border"
            >Back</vs-button
          >
          <input
            type="checkbox"
            v-model="allSelected"
            style="float:right;"
            @click="selectAll"
          />
          <template>
            <vs-button
              :color="acceptButtonColor"
              :disabled="selected.length ? false : true"
              type="filled"
              style="float:right;margin-right: 40px;"
              @click="acceptSelected"
              >{{ accept_text }}</vs-button
            >
          </template>

          <vs-button
            color="primary"
            type="filled"
            style="float:right;margin-right: 20px;"
            @click="finishedSelected"
            >Finished</vs-button
          >
        </div>
      </div>
    </vx-card>
    <vx-card>
      <vs-pagination
        :total="total_pages"
        v-model="currentx"
        goto
      ></vs-pagination>
      <template v-for="(matched_contact, key) in match_contacts">
        <vs-table stripe :key="key" :data="matched_contact" class="mb-20">
          <template slot="header">
            <h3 class="pb-5">Match {{ key + paginate.offset }}</h3>
            <h3 class="pb-5">
              Confidence

              {{ parseFloat(matched_contact.slave.score).toFixed(2) }} {{ "%" }}
            </h3>
            <input
              type="checkbox"
              v-model="selected"
              @click="select"
              :value="{
                uuid: matched_contact.id,
                slave_id: matched_contact.slave.ml_id,
                account_id: matched_contact.slave.account_id
              }"
            />
            <!-- <vs-checkbox
              v-model="selected"
              :vs-value="{'uuid':matched_contact.id,'slave_id':matched_contact.slave.id}"
            ></vs-checkbox> -->
          </template>

          <template slot="thead">
            <vs-th v-if="matched_contact.slave.company_name">Company</vs-th>
            <vs-th v-if="matched_contact.slave.ml_title">Title</vs-th>
            <vs-th v-if="matched_contact.slave.ml_forename"
              >Forename</vs-th
            >
            <vs-th v-if="matched_contact.slave.ml_surname"
              >Surname</vs-th
            >
            <vs-th v-if="matched_contact.slave.ml_job_title"
              >Job title</vs-th
            >

            <vs-th v-if="matched_contact.slave.ml_email">Email</vs-th>
            <vs-th v-if="matched_contact.slave.ml_ddi">DDI</vs-th>
            <vs-th v-if="matched_contact.slave.ml_mobile">Mobile</vs-th>
            <vs-th v-if="matched_contact.slave.ml_social_media">Social Media</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr>
              <vs-td v-if="matched_contact.slave.company_name">
                {{ matched_contact.slave.company_name }}
              </vs-td>
              <vs-td v-if="matched_contact.slave.ml_title">
                {{ matched_contact.title }}
              </vs-td>
              <vs-td v-if="matched_contact.slave.ml_forename">
                {{ matched_contact.forename }}
              </vs-td>
              <vs-td v-if="matched_contact.slave.ml_surname">
                {{ matched_contact.surname }}
              </vs-td>
              <vs-td v-if="matched_contact.slave.ml_job_title">
                {{ matched_contact.job_title }}
              </vs-td>
              <vs-td v-if="matched_contact.slave.ml_email">
                {{ matched_contact.email }}
              </vs-td>
              <vs-td v-if="matched_contact.slave.ml_ddi">
                {{ matched_contact.ddi }}
              </vs-td>
              <vs-td v-if="matched_contact.slave.ml_social_media">
                {{ matched_contact.social_media }}
              </vs-td>
              
            </vs-tr>
            <vs-tr>
              <vs-th v-if="matched_contact.slave.company_name">Company</vs-th>
              <vs-th v-if="matched_contact.slave.ml_title">Title</vs-th>
            <vs-th v-if="matched_contact.slave.ml_forename"
              >Forename</vs-th
            >
            <vs-th v-if="matched_contact.slave.ml_surname"
              >Surname</vs-th
            >
            <vs-th v-if="matched_contact.slave.ml_job_title"
              >Job title</vs-th
            >

            <vs-th v-if="matched_contact.slave.ml_email">Email</vs-th>
            <vs-th v-if="matched_contact.slave.ml_ddi">DDI</vs-th>
            <vs-th v-if="matched_contact.slave.ml_mobile">Mobile</vs-th>
            <vs-th v-if="matched_contact.slave.ml_social_media">Social Media</vs-th>
            </vs-tr>
            <vs-tr>
              <vs-td v-if="matched_contact.slave.company_name">
                {{ matched_contact.slave.company_name }}
              </vs-td>
              <vs-td v-if="matched_contact.slave.ml_title">
                {{ matched_contact.slave.ml_title }}
              </vs-td>
              <vs-td v-if="matched_contact.slave.ml_forename">
                {{ matched_contact.slave.ml_forename }}
              </vs-td>
              <vs-td v-if="matched_contact.slave.ml_surname">
                {{ matched_contact.slave.ml_surname }}
              </vs-td>
               <vs-td v-if="matched_contact.slave.ml_job_title">
                {{ matched_contact.slave.ml_job_title }}
              </vs-td>
              <vs-td v-if="matched_contact.slave.ml_email">
                {{ matched_contact.slave.ml_email }}
              </vs-td>
              <vs-td v-if="matched_contact.slave.ml_ddi">
                {{ matched_contact.slave.ml_ddi }}
              </vs-td>
              <vs-td v-if="matched_contact.slave.ml_mobile">
                {{ matched_contact.slave.ml_mobile }}
              </vs-td>
              <vs-td v-if="matched_contact.slave.ml_social_media">
                {{ matched_contact.slave.ml_social_media }}
              </vs-td>
              <vs-td> </vs-td>
              <vs-td> </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </template>
      <vs-pagination
        :total="total_pages"
        v-model="currentx"
        goto
      ></vs-pagination>
    </vx-card>
  </div>
</template>

<script>
import defineAbilitiesFor from '@/config/abilities'
import Prism from "vue-prism-component";
import vSelect from "vue-select";
import axios from "@/axios.js";
import _ from "lodash";
// import MatchResults from "@/components/Match.vue"
export default {
  components: {
    Prism,
    vSelect
  },
  data() {
    return {
      abilities : null,
campaignId:null,
      match_ten_context: [],
      validation_message: "",
      total_pages: 0,
      limit: 10,
      currentx: 1,
      paginate: { limit: 10, offset: 0 },
      fieldgroups: [
        {
          dbfield: "",
          count: 0,
          uploadfield: [],
          selection: true
        }
      ],
      allSelected: false,
      selected: [],
      count: 0,
      showMatches: false,
      match_contacts: [],
      accept_text: "Accept",
      acceptButtonColor: "primary",
    };
  },
  mounted() {
    this.getMatchedContacts()
  },
  watch: {
    currentx: function(val) {
      this.paginate = { limit: this.limit, offset: (val - 1) * this.limit + 1 };
      this.paginateState();
      this.allSelected = true;
      this.match_ten_context.forEach(
        function(ele) {
          if (ele.page == val && !ele.ten_selected) {
            this.allSelected = false;
          }
        }.bind(this)
      );
    }
  },
  methods: {
    acceptSelected() {
      console.log(this.selected);


      return false
      axios
        .post(
          this.$base_url + "/api/contacts/save_matched_contact",
          {'selected' : this.selected, 'campaignId' : this.campaignId}
        )
        .then(response => {
          if (response.data.status == "success") {
            this.accept_text = "Accepted";
            this.acceptButtonColor = "success";
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    // finishedSelected() {
    //   this.$router.replace("/contacts/import");
    // },
    finishedSelected() {
      let self = this
      this.$router.replace("/contacts/unmatched/" + this.campaignId);
    },
    setSelected(field) {
      // this.list1 = this.list1.filter(function(el) {
      //   return el.name != field.name;
      // });
    },
    ucFirstAllWords(str) {
      var pieces = str.split(" ");
      for (var i = 0; i < pieces.length; i++) {
        var j = pieces[i].charAt(0).toUpperCase();
        pieces[i] = j + pieces[i].substr(1);
      }
      return pieces.join(" ");
    },
    formatUploadedHeader(s) {
      if (typeof s !== "string") return "";
      s = s.replace("_", " ");
      s = s.replace("_", " ");
      s = s.replace("slave", " ");
      s = s.replace("master", " ");
      s = s.replace("_", " ");
      s = s.replace("ml", " ");
      s = s.replace("_", " ");
      return this.ucFirstAllWords(s);
    },
    goBack: function() {
      this.showMatches = false;
      this.showFieldComparision = true;
    },
    removeDuplicates(myArr, prop) {
      return myArr.filter((obj, pos, arr) => {
        return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
      });
    },
    selectAll() {
      let matches = this.match_contacts;

      if (this.allSelected) {
        matches.forEach(match => {
          console.log("MATCH" , match)
          this.selected.pop({ uuid: match.id, slave_id: match.slave.ml_id,account_id: match.slave.account_id });
        });
      } else {
        matches.forEach(match => {
          this.selected.push({ uuid: match.id, slave_id: match.slave.ml_id,account_id: match.slave.account_id });
        });
        this.match_ten_context.map(
          function(ele) {
            if (ele.page == this.currentx) {
              return (ele.ten_selected = true);
            }
          }.bind(this)
        );
      }
    },
    select() {
      this.allSelected = false;
      this.match_ten_context.map(
        function(ele) {
          if (ele.page == this.currentx) {
            return (ele.ten_selected = false);
          }
        }.bind(this)
      );
    },
    getMatchedContacts() {
      // this.$vs.loading();
      axios
        .post(
          this.$base_url + "/api/contacts/get_matched_contacts",
          {'paginate' : this.paginate , 'campaignId' : this.campaignId}
        )
        .then(response => {
          if (response.data.status == "fail") {
            this.validation_message = response.data.message;
          } else {
            this.match_contacts = response.data;
            this.match_contacts = this.match_contacts.filter(ele => ele != null)
            console.log(this.match_contacts)
            this.total_pages = Math.ceil(
              this.match_contacts[0].total_pages / this.limit
            );
            if (this.match_ten_context.length == 0) {
              for (var i = 0; i < this.total_pages; i++) {
                this.match_ten_context.push({
                  page: i + 1,
                  ten_selected: false
                });
              }
            }

            this.showMatches = true;
            this.showFieldComparision = false;
            this.selected = this.removeDuplicates(this.selected, "uuid");
          }
          this.$vs.loading.close();
        })
        .catch(error => {
          console.log(error);
        });
    },
    paginateState() {
      axios
        .post(
          this.$base_url + "/api/contacts/match_contacts_pagination",
          {'paginate' : this.paginate , 'campaignId' : this.campaignId}
        )
        .then(response => {
          if (response.data.status == "fail") {
            this.validation_message = response.data.message;
          } else {
            this.match_contacts = response.data;
            this.total_pages = Math.ceil(
              this.match_contacts[0].total_pages / this.limit
            );
            if (this.match_ten_context.length == 0) {
              for (var i = 0; i < this.total_pages; i++) {
                this.match_ten_context.push({
                  page: i + 1,
                  ten_selected: false
                });
              }
            }

            this.showMatches = true;
            this.showFieldComparision = false;
            this.selected = this.removeDuplicates(this.selected, "uuid");
          }
          this.$vs.loading.close();
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
    created(){
        var self = this
    defineAbilitiesFor().then(function(data){
      self.abilities = data
    });
    this.campaignId = this.$route.params.campaignId;
  }
};
</script>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}
</style>
